import React, { ButtonHTMLAttributes } from "react";

import { useTracking } from "@origin-digital/ods-core";
import styled from "styled-components";

import { IconClose, IconMenu } from "@origin-digital/ods-icons";

const IconButton = styled.button`
  all: unset;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  /*
  ** removes 4px padding from bottom of icons
  ** https://stackoverflow.com/questions/8600393/there-is-a-4px-gap-below-canvas-video-audio-elements-in-html5
  */
  svg {
    display: block;
  }

  &:focus,
  &:focus-visible {
    outline: revert;
  }

  &:hover {
    cursor: pointer;
  }
`;

type TrackedIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  trackingLabel: string;
  "data-id": string;
};

export const TrackedIconButton = ({
  onClick,
  children,
  trackingLabel,
  "data-id": dataId,
  ...rest
}: TrackedIconButtonProps): JSX.Element => {
  const { onClickCapture, ref } = useTracking({
    children: trackingLabel,
    "data-id": dataId,
    type: "Button",
  });

  return (
    <IconButton
      {...rest}
      aria-label={trackingLabel}
      onClick={(e) => {
        onClickCapture?.();
        onClick(e);
      }}
      ref={ref}
      data-id={dataId}
    >
      {children}
    </IconButton>
  );
};

export const Hamburger = styled(TrackedIconButton)`
  margin: auto 16px auto -8px;
  @media (min-width: ${(p) => p.theme.breakpoints.values.lg}px) {
    display: none;
  }
`;

export const TrackedCloseButtonWrapper = styled(TrackedIconButton)`
  margin: auto 16px auto -8px;
  @media (min-width: ${(p) => p.theme.breakpoints.values.lg}px) {
    display: none;
  }
`;

export const HamburgerButton = (props) => (
  <Hamburger {...props}>
    <IconMenu color="neutralDark" />
  </Hamburger>
);

export const CloseButton = (props) => (
  <TrackedCloseButtonWrapper {...props}>
    <IconClose color="neutralDark" />
  </TrackedCloseButtonWrapper>
);
